import Step from "./Step";
import subscribe from "../../subscription/subscribe";

/**
 * @class Step4
 * @extends Step
 *
 * Handles the plan selection step in the registration process.
 */
class Step4 extends Step {
    constructor() {
        super(5, 'plan', $(`[data-register-step="plan"]`));
        this.confirmButton = $("#confirm_subscription");
    }

    /**
     * Initializes the step.
     */
    init() {
        subscribe.initPlanSelectionButtons(false);
        subscribe.selectDefaultPlan(true);
        this.listenForComplete();
    }

    /**
     * Gets the selected plan value.
     * @returns {string} The value of the selected plan.
     */
    get selectedPlan() {
        return document.querySelector('[name="plan"]:checked')?.getAttribute('plan_id') ?? null;
    }

    /**
     * Sets up a listener for when the step is complete.
     */
    listenForComplete() {
        this.confirmButton.off('click').on('click', async (e) => {
            if (!this.selectedPlan) {
                message.error('Selecteer een pakket');
                return;
            }

            // set confirm button to loading state
            this.confirmButton.attr('data-kt-indicator', 'on');

            // send request to server
            await this.postPlan();
        });
    }

    /**
     * Posts the selected plan to the server.
     * @async
     * @returns {Promise<boolean>} True if the post is successful, false otherwise.
     */
    async postPlan() {
        console.log('Selected plan:', this.selectedPlan);

        try {
            let data = await API.post("/register/saveStep", {
                step: 5,
                data: {
                    plan: this.selectedPlan
                }
            });
            if (data.status === 200) {
                // Remove loading state
                this.confirmButton.attr('data-kt-indicator', 'off');

                // Update global plan variable so Step 5 can use it
                if (window.register) {
                    window.register.chosen_plan = this.selectedPlan;
                }

                // Proceed to next step (Demo/Start choice)
                window.register.goNext();
            } else {
                message.error(data.message || 'Er is een fout opgetreden bij het opslaan van uw keuze.');
                this.confirmButton.attr('data-kt-indicator', 'off');
                return false;
            }
        } catch (error) {
            console.error('Error saving plan selection:', error);
            message.error('Er is een fout opgetreden bij het opslaan van uw keuze.');
            this.confirmButton.attr('data-kt-indicator', 'off');
            return false;
        }
    }
}

export default Step4;
